import { render, staticRenderFns } from "./DataStudent.vue?vue&type=template&id=b1d13756&"
import script from "./DataStudent.vue?vue&type=script&lang=js&"
export * from "./DataStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports